(function ($) {
	$(document).ready(function () {
		console.log('accordion test!');
	});
})(jQuery);
